import { useEffect } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../../core/service/useAnalyticsEventTracker";
import { getInvoiceFeature } from "../../../core/service/api_invoice";
import { InvoiceHistoryDetailComponent } from "./ComponentDetailHistoryMobile";

const ComponentInvoiceHistoryDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Invoice",
    });
    getFeature();
  }, []);
  const getFeature = async () => {
    const res = await getInvoiceFeature();
    console.log("res", res);
    localStorage.setItem("invoice-feature", JSON.stringify(res.data));
  };
  return (
    <>
      {/* <BrowserView>
        <ComponentInvoiceWeb></ComponentInvoiceWeb>
      </BrowserView> */}
      <MobileView>
        <InvoiceHistoryDetailComponent />
      </MobileView>
    </>
  );
};
export default ComponentInvoiceHistoryDetail;
